import { AuthError } from "@/enums/AuthError";
import router from "@/router";
import { Component, Vue } from "vue-property-decorator";

@Component
export class HttpErrorHandler extends Vue {
	handleTokenExpired(message: string): void {
		if (message == "jwt expired") {
			router.push(
				"/auth/login?error=" + AuthError.TOKEN_EXPIRED + "&redirectTo=" + router.currentRoute.path
			);
		}
	}

	handleUnauthorized(status: number) {
		if (status == 401) {
			router.push("/auth/login?error=" + AuthError.INSUFFICIENT_PERMISSIONS);
		}
	}
}
